import { render, staticRenderFns } from "./HelpComponent.vue?vue&type=template&id=47b80fcf&scoped=true&"
import script from "./HelpComponent.vue?vue&type=script&lang=ts&"
export * from "./HelpComponent.vue?vue&type=script&lang=ts&"
import style0 from "./HelpComponent.vue?vue&type=style&index=0&id=47b80fcf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b80fcf",
  null
  
)

export default component.exports